import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Phone, ChevronRight, MapPin } from "lucide-react";
import { useSettings } from "@/lib/settings";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/amministrazioni-condominiali/", label: "Condomini" },
  { to: "/agenzia-immobiliare-scandicci/", label: "Agenzia Immobiliare" },
  { to: "/studio-tecnico/", label: "Studio Tecnico" },
  { to: "/immobili", label: "In Vetrina" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/blog", label: "Blog" },
  { to: "/contact/", label: "Contatti" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const settings = useSettings();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50" data-testid="site-header">
      {/* Light utility bar */}
      <div className="bg-[#EEF4F9] text-[#566476] text-xs border-b border-[#DCE6EF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-9">
          <span className="hidden sm:flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#2472C8]" /> Via Salvador Allende 14/c, Scandicci (FI)</span>
          <a href={`tel:${settings.phone}`} className="flex items-center gap-1.5 font-semibold text-[#1B2A41] hover:text-[#2472C8] transition-colors" data-testid="header-phone">
            <Phone className="w-3.5 h-3.5 text-[#2472C8]" /> {settings.phone}
          </a>
        </div>
      </div>

      {/* White main bar */}
      <div className="bg-white/95 backdrop-blur border-b border-[#DCE6EF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-[70px]">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="logo-link">
            <img src="/icon-mono.png" alt="" className="h-11 w-auto" />
            <img src="/wordmark-navy.webp" alt="Edilstudio Immobiliare" className="h-[22px] w-auto" />
          </Link>

          <nav className="hidden lg:flex items-center gap-0.5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-semibold rounded-full whitespace-nowrap transition-colors ${
                    isActive ? "text-[#2472C8] bg-[#EEF4F9]" : "text-[#3A4658] hover:text-[#1B2A41] hover:bg-[#F4F8FB]"
                  }`
                }
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden xl:flex items-center gap-2">
            <button onClick={() => navigate("/valuta-la-tua-casa")} className="px-5 py-2.5 text-sm font-semibold rounded-full bg-[#2472C8] text-white hover:bg-[#1E5FA6] transition-colors shadow-sm shadow-[#2472C8]/20" data-testid="cta-valuta-header">
              Valuta gratis
            </button>
          </div>

          <button className="lg:hidden p-2 text-[#1B2A41]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-b border-[#DCE6EF] px-4 py-4 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)}
              className={({ isActive }) => `flex items-center justify-between px-3 py-3 rounded-xl text-[15px] font-semibold ${isActive ? "text-[#2472C8] bg-[#EEF4F9]" : "text-[#3A4658]"}`}>
              {l.label} <ChevronRight className="w-4 h-4 opacity-40" />
            </NavLink>
          ))}
          <div className="grid grid-cols-2 gap-2 pt-3">
            <button onClick={() => { setOpen(false); navigate("/valuta-la-tua-casa"); }} className="px-3 py-3 text-sm font-semibold rounded-full bg-[#2472C8] text-white">Valuta gratis</button>
            <button onClick={() => { setOpen(false); navigate("/preventivo-condominio"); }} className="px-3 py-3 text-sm font-semibold rounded-full bg-[#EEF4F9] text-[#1B2A41]">Preventivo</button>
          </div>
        </div>
      )}
    </header>
  );
};
